/**
 * ================================
 * COLOR TOKENS - PRODUCTION SYSTEM
 * ================================
 */

export const colors = {
  app: { bg: '#F4F5F6' },
  card: { bg: '#FFFFFF' },
  hero: { bg: '#313638' },
  text: {
    primary: '#1E1F21',
    secondary: '#6A7074',
    muted: '#9CA3AF',
  },
  border: {
    subtle: '#E6E8EA',
  },
  // BOOKING TYPES
  brand: { teal: '#0F8F8D', tealHover: '#0DA3A1', tealTint: 'rgba(15,143,141,0.12)' },
  openPlay: { base: '#3FAF74', hover: '#36C47F', tint: 'rgba(63,175,116,0.12)' },
  coaching: { base: '#0E6F6C', hover: '#107D7B', tint: 'rgba(14,111,108,0.12)' },
  blocks: { base: '#5E6A75', hover: '#4A5560', tint: 'rgba(94,106,117,0.12)' },
  // STATUS
  confirmed: { base: '#0F8F8D', tint: 'rgba(15,143,141,0.12)' },
  held: { base: '#F4A62A', tint: 'rgba(244,166,42,0.12)' },
  review: { base: '#6E6AC9', hover: '#5C58B8', tint: 'rgba(110,106,201,0.12)' },
  expired: { base: '#6C7A89', tint: 'rgba(108,122,137,0.12)' },
};

export const tw = {
  app: { bg: 'bg-app-bg' },
  card: { bg: 'bg-card-bg' },
  text: { primary: 'text-text-primary', secondary: 'text-text-secondary' },
  border: { subtle: 'border-border-subtle' },
  brand: {
    text: 'text-brand-teal', bg: 'bg-brand-teal', bgLight: 'bg-brand-teal-tint',
    border: 'border-brand-teal', hover: 'hover:bg-brand-teal-hover',
  },
  openPlay: {
    text: 'text-open-play', bg: 'bg-open-play', bgLight: 'bg-open-play-tint',
    border: 'border-open-play', hover: 'hover:bg-open-play-hover',
    leftBar: 'border-l-open-play',
  },
  coaching: {
    text: 'text-coaching', bg: 'bg-coaching', bgLight: 'bg-coaching-tint',
    border: 'border-coaching', hover: 'hover:bg-coaching-hover',
  },
  blocked: {
    text: 'text-blocks', bg: 'bg-blocks', bgLight: 'bg-blocks-tint',
    border: 'border-blocks', leftBar: 'border-l-blocks',
  },
  pendingPayment: {
    text: 'text-pending-pay', bg: 'bg-pending-pay', bgLight: 'bg-pending-pay-bg',
    border: 'border-pending-pay', leftBar: 'border-l-pending-pay',
    badgeBg: 'bg-pending-pay-badge', badgeText: 'text-white',
  },
  pendingApproval: {
    text: 'text-pending-appr', bg: 'bg-pending-appr', bgLight: 'bg-pending-appr-bg',
    border: 'border-pending-appr', leftBar: 'border-l-pending-appr',
    badgeBg: 'bg-pending-appr-badge', badgeText: 'text-white',
  },
  confirmed: {
    text: 'text-brand-teal', bg: 'bg-brand-teal', bgLight: 'bg-brand-teal-tint',
    border: 'border-brand-teal', leftBar: 'border-l-brand-teal',
    badgeBg: 'bg-brand-teal', badgeText: 'text-white',
  },
  partialPayment: {
    text: 'text-amber-600', bg: 'bg-amber-500', bgLight: 'bg-amber-50',
    border: 'border-amber-400', leftBar: 'border-l-amber-500',
    badgeBg: 'bg-amber-500', badgeText: 'text-white',
  },
};

export const cn = tw;

export const blockStyles = {
  booking: {
    cell: 'bg-brand-teal-tint border-l-[6px] border-l-brand-teal border-t border-r border-b border-border-subtle',
    card: 'bg-brand-teal-tint border-l-[6px] border-l-brand-teal',
  },
  openPlay: {
    cell: 'bg-open-play-tint border-l-[6px] border-l-open-play border-t border-r border-b border-border-subtle',
    card: 'bg-open-play-tint border-l-[6px] border-l-open-play',
  },
  blocked: {
    cell: 'bg-blocks-tint border-l-[6px] border-l-blocks border-t border-r border-b border-border-subtle',
    card: 'bg-blocks-tint border-l-[6px] border-l-blocks',
  },
  empty: {
    cell: 'bg-transparent border border-border-subtle/50 hover:border-border-subtle hover:bg-white/50',
  },
};

export const buttonStyles = {
  primary: 'bg-brand-teal hover:bg-brand-teal-hover text-white',
  secondary: 'border-brand-teal text-brand-teal hover:bg-brand-teal-tint',
  openPlay: 'border-open-play text-open-play hover:bg-open-play-tint',
  danger: 'border-blocks text-blocks hover:bg-blocks-tint',
  ghost: 'text-text-secondary hover:text-text-primary',
};

export const badgeStyles = {
  confirmed: 'bg-brand-teal text-white',
  openPlayFull: 'bg-open-play text-white',
  pending: 'border border-border-subtle text-text-secondary bg-white',
  partial: 'border border-brand-teal text-brand-teal bg-white',
  proofSent: 'border border-status-review text-status-review bg-white',
  recurring: 'border border-blocks text-blocks bg-white',
  openPlay: 'border border-open-play text-open-play bg-white',
  upcoming: 'border border-brand-teal text-brand-teal bg-white',
  inProgress: 'bg-brand-teal text-white',
  endingSoon: 'bg-brand-teal/80 text-white',
  ended: 'bg-border-subtle text-text-secondary',
};

export const filterStyles = {
  bookings: {
    active: 'bg-brand-teal border-brand-teal text-white',
    inactive: 'bg-white border-brand-teal text-brand-teal',
  },
  openPlay: {
    active: 'bg-open-play border-open-play text-white',
    inactive: 'bg-white border-open-play text-open-play',
  },
  blocks: {
    active: 'bg-blocks border-blocks text-white',
    inactive: 'bg-white border-blocks text-blocks',
  },
};

export const statusStyles = {
  confirmed: {
    chip: {
      active: 'bg-brand-teal-tint border-brand-teal text-brand-teal',
      inactive: 'bg-gray-50/50 border-gray-200 text-gray-400 opacity-60',
      dot: 'bg-brand-teal', dotInactive: 'bg-gray-400',
      badge: 'bg-brand-teal-tint text-brand-teal',
    },
    next: { bg: 'bg-brand-teal-tint', text: 'text-brand-teal', label: 'CONFIRMED' },
    tile: { bg: 'bg-brand-teal-tint', border: 'border-l-brand-teal', text: 'text-brand-teal' },
  },
  pending_payment: {
    chip: {
      active: 'bg-pending-pay-bg border-pending-pay text-pending-pay',
      inactive: 'bg-gray-50/50 border-gray-200 text-gray-400 opacity-60',
      dot: 'bg-pending-pay', dotInactive: 'bg-gray-400',
      badge: 'bg-pending-pay-bg text-pending-pay',
    },
    next: { bg: 'bg-pending-pay-bg', text: 'text-pending-pay', label: 'AWAITING PAYMENT' },
    tile: { bg: 'bg-pending-pay-bg', border: 'border-l-pending-pay', text: 'text-pending-pay' },
  },
  pending_approval: {
    chip: {
      active: 'bg-pending-appr-bg border-pending-appr text-pending-appr',
      inactive: 'bg-gray-50/50 border-gray-200 text-gray-400 opacity-60',
      dot: 'bg-pending-appr', dotInactive: 'bg-gray-400',
      badge: 'bg-pending-appr-bg text-pending-appr',
    },
    next: { bg: 'bg-pending-appr-bg', text: 'text-pending-appr', label: 'NEEDS APPROVAL' },
    tile: { bg: 'bg-pending-appr-bg', border: 'border-l-pending-appr', text: 'text-pending-appr' },
  },
  overdue: {
    chip: {
      active: 'bg-status-held-bg border-status-held text-status-held',
      inactive: 'bg-gray-50/50 border-gray-200 text-gray-400 opacity-60',
      dot: 'bg-status-held', dotInactive: 'bg-gray-400',
      badge: 'bg-status-held-bg text-status-held',
    },
    next: { bg: 'bg-status-held-bg', text: 'text-status-held', label: 'OVERDUE' },
    tile: { bg: 'bg-status-held-bg', border: 'border-l-status-held', text: 'text-status-held' },
  },
  starting_soon: {
    chip: {
      active: 'bg-status-held-bg border-status-held text-status-held',
      inactive: 'bg-gray-50/50 border-gray-200 text-gray-400 opacity-60',
      dot: 'bg-status-held', dotInactive: 'bg-gray-400',
      badge: 'bg-status-held-bg text-status-held',
    },
    next: { bg: 'bg-status-held-bg', text: 'text-status-held', label: 'STARTING SOON' },
    tile: { bg: 'bg-status-held-bg', border: 'border-l-status-held', text: 'text-status-held' },
  },
  empty: {
    chip: {
      active: 'bg-gray-100 border-gray-400 text-gray-700',
      inactive: 'bg-gray-50/50 border-gray-200 text-gray-400 opacity-60',
      dot: 'bg-gray-500', dotInactive: 'bg-gray-400',
      badge: 'bg-gray-100 text-gray-600',
    },
    next: { bg: 'bg-gray-100', text: 'text-gray-500', label: 'AVAILABLE' },
    tile: { bg: 'bg-gray-100', border: 'border-l-gray-400', text: 'text-gray-500' },
  },
  open_play: {
    chip: {
      active: 'bg-open-play-tint border-open-play text-open-play',
      inactive: 'bg-gray-50/50 border-gray-200 text-gray-400 opacity-60',
      dot: 'bg-open-play', dotInactive: 'bg-gray-400',
      badge: 'bg-open-play-tint text-open-play',
    },
    next: { bg: 'bg-open-play-tint', text: 'text-open-play', label: 'OPEN PLAY' },
    tile: { bg: 'bg-open-play-tint', border: 'border-l-open-play', text: 'text-open-play' },
  },
  partial_payment: {
    chip: {
      active: 'bg-amber-50 border-amber-400 text-amber-700',
      inactive: 'bg-gray-50/50 border-gray-200 text-gray-400 opacity-60',
      dot: 'bg-amber-500', dotInactive: 'bg-gray-400',
      badge: 'bg-amber-50 text-amber-700',
    },
    next: { bg: 'bg-amber-50', text: 'text-amber-700', label: 'BALANCE DUE' },
    tile: { bg: 'bg-amber-50', border: 'border-l-amber-500', text: 'text-amber-700' },
  },
};

// Dev helpers - no-op in production
export function findHardcodedColors() { return []; }
export function checkForHardcodedColors() {}
export function useColorCheck() {}
export function initColorTokenWarnings() {}
